import { render, staticRenderFns } from "./withdrawGift.html?vue&type=template&id=513937a1&scoped=true&"
import script from "./withdrawGift.vue?vue&type=script&lang=js&"
export * from "./withdrawGift.vue?vue&type=script&lang=js&"
import style0 from "./withdrawGift.vue?vue&type=style&index=0&id=513937a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513937a1",
  null
  
)

export default component.exports